import {queryToString} from '@wix/wixstores-client-storefront-sdk/dist/src/services/utils';
import {Experiments} from '../constants';
import {ReadOnlyExperiments} from '@wix/wix-experiments';

export enum WarmUpDataRequestType {
  PRODUCTS = 'products',
  INITIAL_DATA = 'initialData',
  OLD_INITIAL_DATA = 'oldInitialData',
  CATEGORY_INITIAL_DATA = 'categoryInitialData',
  FILTERS = 'filters',
}

export function isWarmUpDataEnabled(experiments: ReadOnlyExperiments): boolean {
  return experiments.enabled(Experiments.EnableWarmUpDataCaching);
}

/* istanbul ignore next */
export function oldGenerateCacheKeySuffix(
  query: Record<string, any>,
  mainCollectionId: string | null,
  compId: string
): string {
  const collection = mainCollectionId || 'default';
  const componentId = compId;
  const urlParams = queryToString(query) || 'default';
  return `${collection}_${componentId}_${urlParams}`;
}

/* istanbul ignore next */
export function oldCreateWarmUpDataKey(requestType: WarmUpDataRequestType, suffix: string): string {
  return `${requestType}_${suffix}`;
}

export function generateComponentCollectionCacheKey(mainCollectionId: string | null, compId: string) {
  const collection = mainCollectionId || 'default';
  return `${collection}_${compId}`;
}

export function createWarmUpDataKey(
  requestType: WarmUpDataRequestType,
  cacheKeyOrComponentCollectionKey: string,
  query?: Record<string, any>
): string {
  const urlParams = queryToString(query) || 'default';
  return `${requestType}_${cacheKeyOrComponentCollectionKey}_${urlParams}`;
}
